/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

import React from 'react';
import PropTypes from 'prop-types';
import { useQRCode } from 'react-qrcode';

const qrSource = 'company';
const version = 3;

export function QRCode({
  height, patientId, patientName, companyId, size, type = 'image/webp', width = 300,
}) {
  const url = useQRCode({
    value: getQRCodeString(patientId, patientName, companyId),
    width: size,
    type,
  });

  return (
    <img
      width={width}
      alt={`qr ${patientName}`}
      height={height}
      src={url}
    />
  );
}

export function getQRCodeString(patientId, patientName, companyId) {
  return `${patientId};${patientName};${version};${qrSource};${companyId}`;
}

QRCode.propTypes = {
  height: PropTypes.string.isRequired,
  patientId: PropTypes.string.isRequired,
  patientName: PropTypes.string.isRequired,
  companyId: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
};

export default QRCode;
